module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"childAlert":"By responding Yes, you are also required to answer:"},"de":{"childAlert":"Wenn Sie mit \\"Ja\\" antworten, müssen Sie auch Folgendes beantworten:"}}')
  delete Component.options._Ctor
}
